import {
  GET_ORDER_COLLECTION_REQUEST,
  GET_ORDER_COLLECTION_SUCCESS,
  GET_ORDER_COLLECTION_FAIL,
  GET_PARTSKART_ORDER_REQUEST,
  GET_PARTSKART_ORDER_SUCCESS,
  GET_PARTSKART_ORDER_FAIL,
} from "../constants/constants";

const initialState = {
  chart_label: "",
  total_order_collection: 0,
  results: [],
  loading: false,
  error: null,
  pendingRequestsCount: 0,
};
const partskartOrderInitialState = {
  chart_label: "",
  total_order_collection: 0,
  results: [],
  loading: false,
  error: null,
  pendingRequestsCount: 0,
};

export const orderCollectionReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ORDER_COLLECTION_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
      };

    case GET_ORDER_COLLECTION_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      const { chart_label, total_order_collection, results } = payload;

      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        chart_label,
        total_order_collection,
        results,
      };

    case GET_ORDER_COLLECTION_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        error: payload,
        chart_label: "",
        total_order_collection: 0,
        results: [],
      };

    default:
      return state;
  }
};
export const partskartOrderCollectionReducer = (
  state = partskartOrderInitialState,
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case GET_PARTSKART_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        pendingRequestsCount: state.pendingRequestsCount + 1, // Increment on request
      };

    case GET_PARTSKART_ORDER_SUCCESS:
      const pendingAfterSuccess = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on success
      const { chart_label, total_order_collection, results } = payload;

      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterSuccess,
        loading: pendingAfterSuccess > 0, // Keep loader if there are pending requests
        chart_label,
        total_order_collection,
        results,
      };

    case GET_PARTSKART_ORDER_FAIL:
      const pendingAfterFail = Math.max(state.pendingRequestsCount - 1, 0); // Decrement on failure
      return {
        ...state,
        // loading: false,
        pendingRequestsCount: pendingAfterFail,
        loading: pendingAfterFail > 0, // Keep loader if there are pending requests
        error: payload,
        chart_label: "",
        total_order_collection: 0,
        results: [],
      };

    default:
      return state;
  }
};
